<script lang="ts" setup>
import { defineProps } from "vue";
import { defineEmits } from "vue";

const emit = defineEmits(["update-range"]);
const props = defineProps<{ value: number[] }>();

const change = (value: any) => {
  emit("update-range", value);
};
</script>

<template>
  <div class="facet-range">
    <ElDropdown placement="bottom-start" :hide-on-click="false">
      <ElTag type="primary" effect="plain">VIL (level)</ElTag>
      <template #dropdown>
        <ElDropdownMenu>
          <ElDropdownItem>
            <ElSlider
              :model-value="props.value"
              :max="6"
              :min="1"
              :step="1"
              range
              show-stops
              :marks="{
                1: '1',
                2: '2',
                3: '3',
                4: '4',
                5: '5',
                6: '6',
              }"
              @input="change"
            />
          </ElDropdownItem>
        </ElDropdownMenu>
      </template>
    </ElDropdown>
  </div>
</template>

<style lang="scss">
.el-slider {
  width: 300px;

  &__bar,
  &__button {
    background-color: #225da6;
  }

  &__button {
    margin-top: 3px;
    border-color: #2873cb;
  }

  &__stop {
    background-color: #2873cb;
  }

  &__marks {
    display: flex;
    flex-direction: row;
    padding-top: 8px;
    align-items: center;
    justify-content: space-between;
  }

  .el_tooltip {
    background-color: green;
  }
}
</style>
